/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataRemovalRequestStatusSchema = z.enum([
	'pending',
	'notified',
	'approved',
	'rejected',
	'completed',
	'expired',
])

export type DataRemovalRequestStatusSchema = z.infer<typeof dataRemovalRequestStatusSchema>
